document.addEventListener('DOMContentLoaded', () => {
  initializeCollectionPage();
});

document.addEventListener('section:load', function () {
  initializeCollectionPage();
});

function isDesktopDevice() {
  // Check if the device has a screen width greater than 768px
  return window.matchMedia('(min-width: 769px)').matches;
}


function initializeCollectionPage() {
  if (isDesktopDevice()) {
    // Handle size selection changes
    document.querySelectorAll('.size-option:not(.add-cart)').forEach(sizeSelector => {
      sizeSelector.addEventListener('click', handleOptionChange);
    });
  }

  bindCollectionEvents();
  setupCollectionGalleryObserver();
  bindCardGalleryResizeUpdates();
}

let collectionEventsBound = false;
let collectionGalleryObserver;
let cardGalleryResizeBound = false;
let cardGalleryResizeTimer;
const galleryPreloadedUrls = new Set();
const CARD_GALLERY_CARET_ICON_HTML =
  '<svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path></svg>';
const CARD_GALLERY_LOADER_SHOW_DELAY_MS = 200;

function bindCollectionEvents() {
  if (collectionEventsBound) return;
  collectionEventsBound = true;

  document.addEventListener('click', function (event) {
    const swatch = event.target.closest('.variant-swatch');
    if (swatch && swatch.closest('.color-swatches.list')) {
      event.stopPropagation();
      syncCardGalleryWithSwatch(swatch, event.target);
      handleImageClick(event);
      handleOptionChange(event);
    }
  });
}

function getGallerySwiperEl(track) {
  return track && track.querySelector('.card-image-swiper');
}

function getCardGallerySwiper(track) {
  const swiperEl = getGallerySwiperEl(track);
  return swiperEl?.swiper && !swiperEl.swiper.destroyed ? swiperEl.swiper : null;
}

function destroyCardGallerySwiper(track) {
  const swiper = getCardGallerySwiper(track);
  if (swiper) {
    swiper.destroy(true, true);
  }
  if (track) {
    delete track.dataset.cardGallerySwiperBound;
  }
}

function updateAllCardGallerySwipers() {
  document.querySelectorAll('.card-image-swiper').forEach((swiperEl) => {
    const swiper = swiperEl.swiper;
    if (swiper && !swiper.destroyed) {
      swiper.update();
    }
  });
}

function scheduleCardGallerySwiperUpdate() {
  if (cardGalleryResizeTimer) clearTimeout(cardGalleryResizeTimer);
  cardGalleryResizeTimer = setTimeout(updateAllCardGallerySwipers, 150);
}

function bindCardGalleryResizeUpdates() {
  if (cardGalleryResizeBound) return;
  cardGalleryResizeBound = true;
  window.addEventListener('resize', scheduleCardGallerySwiperUpdate);
}

function syncCardGalleryUi(track, swiper) {
  if (!track || !swiper) return;

  const index = swiper.activeIndex;
  track.querySelectorAll('.card-gallery-dot').forEach((dot, i) => {
    dot.classList.toggle('is-active', i === index);
  });

  const prevButton = track.querySelector('.card-gallery-nav.prev');
  const nextButton = track.querySelector('.card-gallery-nav.next');
  setGalleryNavDisabled(prevButton, swiper.isBeginning);
  setGalleryNavDisabled(nextButton, swiper.isEnd);
}

function buildCardGallerySwiperConfig(track) {
  const swiperEl = getGallerySwiperEl(track);
  const prevEl = track.querySelector('.card-gallery-nav.prev');
  const nextEl = track.querySelector('.card-gallery-nav.next');
  const slideCount = swiperEl ? swiperEl.querySelectorAll('.swiper-slide').length : 0;

  const config = {
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 0,
    roundLengths: true,
    observer: true,
    observeParents: true,
    resizeObserver: true,
    speed: 300,
    watchOverflow: true,
    resistance: true,
    resistanceRatio: 0.85,
    threshold: 10,
    shortSwipes: true,
    longSwipes: true,
    longSwipesRatio: 0.5,
    touchAngle: 40,
    touchRatio: 0.5,
    touchStartPreventDefault: false,
    preventInteractionOnTransition: true,
    nested: true,
    passiveListeners: true,
    lazyPreloadPrevNext: 3,
    on: {
      init(swiper) {
        syncCardGalleryUi(track, swiper);
      },
      slideChange(swiper) {
        syncCardGalleryUi(track, swiper);
      },
    },
  };

  if (slideCount > 1 && prevEl && nextEl) {
    config.navigation = {
      prevEl,
      nextEl,
    };
  }

  return config;
}

function cloneCardGallerySlideLoader(gallery) {
  const template = gallery?.querySelector('template.card-gallery-slide-loader-template');
  if (!template?.content?.firstElementChild) return null;
  return template.content.firstElementChild.cloneNode(true);
}

function bindCardGallerySlideLoaders(container) {
  if (!container) return;

  container.querySelectorAll('.card-image-slide').forEach((slide) => {
    const img = slide.querySelector(':scope > img');
    const loader = slide.querySelector('.card-gallery-slide-loading');
    if (!img || !loader || slide.dataset.galleryLoaderBound === 'true') return;

    slide.dataset.galleryLoaderBound = 'true';

    let showLoaderTimer = null;

    const markLoaded = () => {
      if (showLoaderTimer) {
        clearTimeout(showLoaderTimer);
        showLoaderTimer = null;
      }
      slide.classList.remove('is-loading');
      slide.classList.add('is-loaded');
    };

    if (img.complete && img.naturalWidth > 0) {
      markLoaded();
      return;
    }

    showLoaderTimer = setTimeout(() => {
      showLoaderTimer = null;
      if (!slide.classList.contains('is-loaded')) {
        slide.classList.add('is-loading');
      }
    }, CARD_GALLERY_LOADER_SHOW_DELAY_MS);

    img.addEventListener('load', markLoaded, { once: true });
    img.addEventListener('error', markLoaded, { once: true });
  });
}

function initCardGallerySwiper(track) {
  if (!track || typeof Swiper === 'undefined') return null;

  const swiperEl = getGallerySwiperEl(track);
  if (!swiperEl) return null;

  bindCardGallerySlideLoaders(track);

  const slideCount = swiperEl.querySelectorAll('.swiper-slide').length;
  if (slideCount < 2) {
    track.dataset.cardGallerySwiperBound = 'true';
    const prevButton = track.querySelector('.card-gallery-nav.prev');
    const nextButton = track.querySelector('.card-gallery-nav.next');
    setGalleryNavDisabled(prevButton, true);
    setGalleryNavDisabled(nextButton, true);
    return null;
  }

  destroyCardGallerySwiper(track);

  const swiper = new Swiper(swiperEl, buildCardGallerySwiperConfig(track));
  track.dataset.cardGallerySwiperBound = 'true';
  return swiper;
}

/** Delegated click handler on `.card-image-gallery` so dots work before parent `.media`. */
function bindGalleryControlHandlers(gallery) {
  if (!gallery || gallery.dataset.galleryControlsBound === 'true') return;
  gallery.dataset.galleryControlsBound = 'true';

  gallery.addEventListener('click', function (event) {
    const dotButton = event.target.closest('.card-gallery-dot');
    if (dotButton) {
      event.preventDefault();
      event.stopPropagation();
      const dotIndex = parseInt(dotButton.dataset.dotIndex, 10);
      const activeTrack = gallery.querySelector('.card-image-track:not(.hidden)');
      const swiper = activeTrack ? getCardGallerySwiper(activeTrack) : null;
      if (swiper) {
        swiper.slideTo(Number.isNaN(dotIndex) ? 0 : dotIndex);
      }
      return;
    }

    if (event.target.closest('.card-gallery-nav')) {
      event.stopPropagation();
      return;
    }

    event.stopPropagation();
  });
}

function setupCollectionGalleryObserver() {
  const galleries = document.querySelectorAll('.card-image-gallery');
  if (!galleries.length) return;

  if (!collectionGalleryObserver) {
    collectionGalleryObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        preloadGallerySwatchHeroes(entry.target);
        initializeCardGallery(entry.target);
        collectionGalleryObserver.unobserve(entry.target);
      });
    }, { rootMargin: '180px 0px' });
  }

  galleries.forEach((gallery) => {
    bindGalleryControlHandlers(gallery);
    bindCardGallerySlideLoaders(gallery);
    if (gallery.dataset.galleryObserved === 'true') return;
    gallery.dataset.galleryObserved = 'true';
    collectionGalleryObserver.observe(gallery);
  });
}

function setGalleryNavDisabled(button, isDisabled) {
  if (!button) return;
  button.disabled = isDisabled;
  button.classList.toggle('is-disabled', isDisabled);
  button.setAttribute('aria-disabled', isDisabled ? 'true' : 'false');
}

function getGalleryConfig(gallery) {
  if (!gallery) return null;
  if (gallery._galleryConfig) return gallery._galleryConfig;

  const configScript = gallery.querySelector('script[data-card-image-gallery-config]');
  if (!configScript) return null;

  try {
    gallery._galleryConfig = JSON.parse(configScript.textContent);
  } catch (error) {
    console.error('Unable to parse card image gallery config', error);
    return null;
  }

  return gallery._galleryConfig;
}

function getGalleryColorConfig(gallery, colorName) {
  const config = getGalleryConfig(gallery);
  if (!config || !Array.isArray(config.colors)) return null;
  return config.colors.find((colorConfig) => colorConfig.name === colorName) || null;
}

function preloadGalleryImageUrl(url) {
  if (!url || galleryPreloadedUrls.has(url)) return;
  galleryPreloadedUrls.add(url);
  const loader = new Image();
  loader.decoding = 'async';
  loader.src = url;
}

function getGallerySlideSrc(slide) {
  if (!slide) return '';
  if (typeof slide === 'string') return slide;
  return slide.src || '';
}

function preloadGallerySwatchHeroes(gallery) {
  if (!gallery || gallery.dataset.swatchHeroesPreloaded === 'true') return;

  const config = getGalleryConfig(gallery);
  if (!config || !Array.isArray(config.colors)) return;

  gallery.dataset.swatchHeroesPreloaded = 'true';

  config.colors.forEach((colorConfig) => {
    preloadGalleryImageUrl(getGallerySlideSrc(colorConfig.slides?.[0]));
  });
}

function applyCardGalleryImageAttributes(img, slide) {
  const slideData = typeof slide === 'string' ? { src: slide } : slide || {};
  img.width = 624;
  img.height = 936;
  if (slideData.src) {
    img.src = slideData.src;
  }
}

function buildGalleryTrack(gallery, colorName, colorConfig) {
  const config = getGalleryConfig(gallery);
  const slides = Array.isArray(colorConfig.slides) ? colorConfig.slides : [];
  const variantUrl = colorConfig.variantUrl || '#';
  const productTitle = config?.productTitle || '';

  const track = document.createElement('div');
  track.className = 'card-image-track';
  track.dataset.colorTrack = colorName;

  const swiperEl = document.createElement('div');
  swiperEl.className = 'card-image-scroll card-image-swiper swiper';
  swiperEl.tabIndex = 0;

  const wrapper = document.createElement('div');
  wrapper.className = 'swiper-wrapper';

  slides.forEach((slide, index) => {
    const link = document.createElement('a');
    link.href = variantUrl;
    link.className = 'card-image-slide swiper-slide';
    link.dataset.slideIndex = String(index);

    const image = document.createElement('img');
    image.alt = productTitle;
    image.loading = index === 0 ? 'eager' : 'lazy';
    applyCardGalleryImageAttributes(image, slide);

    link.appendChild(image);
    const loader = cloneCardGallerySlideLoader(gallery);
    if (loader) link.appendChild(loader);
    wrapper.appendChild(link);
  });

  swiperEl.appendChild(wrapper);
  track.appendChild(swiperEl);

  const prevButton = document.createElement('button');
  prevButton.type = 'button';
  prevButton.className = `card-gallery-nav prev${slides.length < 2 ? ' hidden' : ''}`;
  prevButton.dataset.direction = 'prev';
  prevButton.setAttribute('aria-label', 'Previous image');
  prevButton.innerHTML = `<span>${CARD_GALLERY_CARET_ICON_HTML}</span>`;

  const nextButton = document.createElement('button');
  nextButton.type = 'button';
  nextButton.className = `card-gallery-nav next${slides.length < 2 ? ' hidden' : ''}`;
  nextButton.dataset.direction = 'next';
  nextButton.setAttribute('aria-label', 'Next image');
  nextButton.innerHTML = `<span>${CARD_GALLERY_CARET_ICON_HTML}</span>`;

  const dots = document.createElement('div');
  dots.className = `card-gallery-dots${slides.length < 2 ? ' hidden' : ''}`;

  slides.forEach((slide, index) => {
    const dot = document.createElement('button');
    dot.type = 'button';
    dot.className = `card-gallery-dot${index === 0 ? ' is-active' : ''}`;
    dot.dataset.dotIndex = String(index);
    dot.setAttribute('aria-label', `Go to image ${index + 1}`);
    dots.appendChild(dot);
  });

  track.appendChild(prevButton);
  track.appendChild(nextButton);
  track.appendChild(dots);

  return track;
}

function ensureGalleryTrack(gallery, colorName) {
  if (!gallery || !colorName) return null;

  const existingTrack = gallery.querySelector(
    `.card-image-track[data-color-track="${escapeSelectorValue(colorName)}"]`
  );
  if (existingTrack && gallery.querySelectorAll('.card-image-track').length === 1) {
    return existingTrack;
  }

  const colorConfig = getGalleryColorConfig(gallery, colorName);
  if (!colorConfig) return null;

  gallery.querySelectorAll('.card-image-track').forEach((track) => {
    destroyCardGallerySwiper(track);
    track.remove();
  });

  const nextTrack = buildGalleryTrack(gallery, colorName, colorConfig);
  const configScript = gallery.querySelector('script[data-card-image-gallery-config]');
  if (configScript) {
    gallery.insertBefore(nextTrack, configScript);
  } else {
    gallery.appendChild(nextTrack);
  }

  return nextTrack;
}

function initializeCardGallery(gallery) {
  if (!gallery || gallery.dataset.galleryInitialized === 'true') return;
  gallery.dataset.galleryInitialized = 'true';

  const activeTrack =
    gallery.querySelector(
      `.card-image-track[data-color-track="${escapeSelectorValue(gallery.dataset.activeColor || '')}"]`
    ) || gallery.querySelector('.card-image-track');
  if (activeTrack) {
    activateTrack(gallery, activeTrack);
  }
}

function syncCardGalleryWithSwatch(swatch, sourceElement = null) {
  const productId = swatch.getAttribute('data-product-id');
  const color = swatch.getAttribute('data-color');
  if (!productId || !color) return;

  const scopeCard = (sourceElement || swatch).closest('.card-wrapper');
  const scopedGallery = scopeCard
    ? scopeCard.querySelector(`.card-image-gallery[data-product-id="${escapeSelectorValue(productId)}"]`) ||
      scopeCard.querySelector('.card-image-gallery')
    : null;
  const gallery =
    scopedGallery ||
    document.querySelector(`.card-image-gallery[data-product-id="${escapeSelectorValue(productId)}"]`);
  if (!gallery) return;

  initializeCardGallery(gallery);

  const targetTrack = ensureGalleryTrack(gallery, color);
  if (!targetTrack) return;
  gallery.dataset.activeColor = color;
  activateTrack(gallery, targetTrack);
}

function activateTrack(gallery, targetTrack) {
  if (!targetTrack) return;

  gallery.querySelectorAll('.card-image-track').forEach((track) => {
    if (track !== targetTrack) {
      destroyCardGallerySwiper(track);
      track.remove();
    }
  });
  targetTrack.classList.remove('hidden');
  initCardGallerySwiper(targetTrack);
}

function rotateTrackSlides(gallery, direction) {
  if (gallery.dataset.galleryInitialized !== 'true') initializeCardGallery(gallery);
  const activeTrack = gallery.querySelector('.card-image-track:not(.hidden)');
  if (!activeTrack) return;
  const swiper = getCardGallerySwiper(activeTrack);
  if (!swiper) return;
  if (direction > 0) swiper.slideNext();
  else swiper.slidePrev();
}

function scrollGalleryToIndex(gallery, targetIndex) {
  if (gallery.dataset.galleryInitialized !== 'true') initializeCardGallery(gallery);
  const activeTrack = gallery.querySelector('.card-image-track:not(.hidden)');
  if (!activeTrack) return;
  const swiper = getCardGallerySwiper(activeTrack);
  const slides = activeTrack.querySelectorAll('.swiper-slide');
  if (!slides.length) return;
  const max = slides.length - 1;
  const i = Math.max(0, Math.min(targetIndex, max));
  if (swiper) swiper.slideTo(i);
}

function escapeSelectorValue(value) {
  if (window.CSS && typeof window.CSS.escape === 'function') {
    return window.CSS.escape(value);
  }
  return String(value).replace(/"/g, '\\"');
}
// Handle option change logic
function handleOptionChange(event) {
  if (event.target.classList.contains('add-cart')) return;

  const sizeOptions = event.target.closest('.size-options');
  if (sizeOptions?.classList.contains('size-options--loading')) return;

  const productId = event.target.closest('[data-product-id]').getAttribute('data-product-id');
  //const sizeSelector = document.querySelector(`.size-selector[data-product-id="${productId}"]`);
  //const selectedSize = sizeSelector ? sizeSelector.value : null;
  const selectedSize = event.target.textContent.trim();

  //check if the selected size empty then check the available size using the 
  //
  
  const dataColor = event.target.closest('.variant-swatch')?.getAttribute('data-color') || null;
  const activeSwatch = document.querySelector(`.variant-swatch.active[data-product-id="${productId}"]`);
  const selectedColor = dataColor ? dataColor  : activeSwatch.getAttribute('data-color');

  
  if (!selectedSize) {
    updateAvailableSizes(productId, selectedColor);
  }



  // Find the variant ID based on selected size and color
  const variantId = findVariantId(productId, selectedColor, selectedSize);
  

  // Update Add to Cart button state
  updateAddToCartState(productId, selectedSize, selectedColor, variantId);
}

function updateAvailableSizes(productId, selectedColor) {
  const noScriptInputWrapper = document.createElement('div');
  noScriptInputWrapper.innerHTML = document.querySelector(`.product-list__noscript-wrapper-${productId}`).innerHTML;
  const variantSelect = noScriptInputWrapper.querySelector(`select#Variants-${productId}`);
  const availableSizes = [];

  // Iterate through the options in the variantSelect element
  Array.from(variantSelect.options).forEach(option => {
    if (!option.disabled) {
        // Split the option text into color and size
        const [color, size] = option.text.split('/').map(str => str.trim());
        // Match color exactly
        if (color === selectedColor) {
            availableSizes.push({ size, variantId: option.value });
        }
    }
  });

  // Get the size-selector div
  const sizeSelectorDiv = document.querySelector(`.size-selector[data-product-id="${productId}"]`);
  
  if (!sizeSelectorDiv) {
    return;
  }
  
  // Get the parent .size-options div
  const sizeOptionsDiv = sizeSelectorDiv.closest('.size-options');
  
  // Add 'no-size-available' class if availableSizes is empty
  if (sizeOptionsDiv) {
    if (availableSizes.length === 0) {
      sizeOptionsDiv.classList.add('no-size-available');
    } else {
      sizeOptionsDiv.classList.remove('no-size-available');
    }
  }
  
  sizeSelectorDiv.innerHTML = ''; // Clear existing options

  // Create and append size-option spans
  availableSizes.forEach(({ size, variantId }) => {
      const span = document.createElement('span');
      span.className = 'size-option';      
      span.setAttribute('data-variant-id', variantId);
      span.textContent = size;
      span.addEventListener('click', handleOptionChange);
      sizeSelectorDiv.appendChild(span);
  });
}

function findVariantId(productId, color, size) {
  const noScriptInputWrapper = document.createElement('div');
  noScriptInputWrapper.innerHTML = document.querySelector(`.product-list__noscript-wrapper-${productId}`).innerHTML;
  const variantSelect = noScriptInputWrapper.querySelector(`select#Variants-${productId}`);
  if (!variantSelect) return null;

  const options = variantSelect.querySelectorAll('option');

  for (const option of options) {
    const variantText = option.textContent.trim();
    const [variantColor, variantSize] = variantText.split(' / ');
    if (variantColor === color && variantSize === size) {
      return option.value;
    }
  }
  return null;
}

function findVariantPrices(productId, variantId) {
  const noScriptInputWrapper = document.createElement('div');
  noScriptInputWrapper.innerHTML = document.querySelector(`.product-list__noscript-wrapper-${productId}`).innerHTML;
  const variantSelect = noScriptInputWrapper.querySelector(`select#Variants-${productId}`);
  if (!variantSelect) return null;

  const option = variantSelect.querySelector(`option[value="${variantId}"]`);
  if (!option) return null;

  const priceAttr = option.getAttribute('data-price');
  const compareAtPriceAttr = option.getAttribute('data-compare-at-price');
  
  const price = priceAttr ? parseFloat(priceAttr) : null;
  const compareAtPrice = compareAtPriceAttr && compareAtPriceAttr !== '' ? parseFloat(compareAtPriceAttr) : null;

  return {
    price: price,
    compareAtPrice: compareAtPrice
  };
}

function setSizeOptionsLoading(productId, isLoading) {
  const sizeOptions = document
    .querySelector(`.size-selector[data-product-id="${productId}"]`)
    ?.closest('.size-options');
  if (!sizeOptions) return;

  const label = sizeOptions.querySelector('.size-option.add-cart');

  if (isLoading) {
    if (label) {
      if (!label.dataset.originalText) label.dataset.originalText = label.textContent;
      label.textContent = window.variantStrings?.adding || 'ADDING...';
    }
    sizeOptions.classList.add('size-options--loading');
    return;
  }

  if (label?.dataset.originalText) label.textContent = label.dataset.originalText;
  sizeOptions.classList.remove('size-options--loading');
}

function updateAddToCartState(productId, size, color, variantId) {
  if (size && color && variantId) {
    setSizeOptionsLoading(productId, true);
    // Get variant price data from select option to check if on sale
    let properties = {};
    if (AFTERSHIP_PROPERTIES && AFTERSHIP_PROPERTIES.ENABLE_FINAL_SALE_PROPERTY) {
      const variantPrices = findVariantPrices(productId, variantId);
      if (variantPrices && variantPrices.compareAtPrice && variantPrices.price && variantPrices.compareAtPrice > variantPrices.price) {
        properties[AFTERSHIP_PROPERTIES.FINAL_SALE_KEY] = AFTERSHIP_PROPERTIES.FINAL_SALE_VALUE;
      }
    }

    const cartData = {
      id: variantId,
      quantity: 1
    };

    // Add properties if variant is on sale
    if (Object.keys(properties).length > 0) {
      cartData.properties = properties;
    }

    // Attach event listener for Add to Cart
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(cartData),
      })
        .then(response => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.json();
        })
        .then(data => {
          // Store the latest added variant ID
          localStorage.setItem('latestAddedVariantId', variantId);
          
          // Dispatch cart update event for complete look section
          if (typeof PUB_SUB_EVENTS !== 'undefined' && typeof publish !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'collection-page',
              productVariantId: variantId,
              cartData: data
            });
          }
          
          // Add delay to ensure server has processed cart update
          setTimeout(() => {
            updateCartDrawer();
          }, 150);
        })
        .catch(error => {
          console.error('Error adding to cart:', error);
        })
        .finally(() => {
          setSizeOptionsLoading(productId, false);
        });
  } else {
    //addToCartButton.disabled = true;
  }
}

function updateCartDrawer() {
  $('cart-drawer').addClass('drawer animate active');
  $('cart-drawer').removeClass('is-empty');
  $('.drawer__inner-empty').hide();
  document.body.classList.add('overflow-hidden');
  //$('cart-drawer').load(location.href + "#CartDrawer");   
  fetch(`${routes.cart_url}?section_id=cart-drawer`)
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      const selectors = ['cart-drawer-items', '.cart-drawer__footer', '.shipping-progress-container', '.cart-drawer__recommendations'];
      for (const selector of selectors) {
        const targetElement = document.querySelector(selector);
        const sourceElement = html.querySelector(selector);
        if (targetElement && sourceElement) {
          targetElement.replaceWith(sourceElement);
        } else if (targetElement && !sourceElement) {
          // If target exists but source doesn't (e.g., shipping progress when cart becomes empty), remove target
          targetElement.remove();
        } else if (!targetElement && sourceElement) {
          // If source exists but target doesn't (e.g., shipping progress when cart gets first item), add source
          if (selector === '.shipping-progress-container') {
            // Insert shipping progress before cart-drawer-items
            const cartDrawerItems = document.querySelector('cart-drawer-items');
            if (cartDrawerItems) {
              cartDrawerItems.parentNode.insertBefore(sourceElement, cartDrawerItems);
            }
          } else if (selector === '.cart-drawer__recommendations') {
            // Insert recommendations AFTER drawer__footer
            const drawerFooter = document.querySelector('.drawer__footer');
            if (drawerFooter) {
              drawerFooter.parentNode.insertBefore(sourceElement, drawerFooter.nextSibling);
            } else {
              // Fallback: insert at the end of drawer__contents-wrapper
              const contentsWrapper = document.querySelector('.drawer__contents-wrapper');
              if (contentsWrapper) {
                contentsWrapper.appendChild(sourceElement);
              }
            }
          } else {
            // For other selectors, insert before cart-drawer-items
            const insertBeforeElement = document.querySelector('cart-drawer-items');
            if (insertBeforeElement) {
              insertBeforeElement.parentNode.insertBefore(sourceElement, insertBeforeElement);
            }
          }
        }
      }

      // ✅ Ensure correct final order: items → footer → recommendations
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        const items = cartDrawer.querySelector('cart-drawer-items');
        const footer = cartDrawer.querySelector('.drawer__footer');
        const recommendations = cartDrawer.querySelector('.cart-drawer__recommendations');

        if (items && footer && recommendations) {
          if (footer.nextElementSibling !== recommendations) {
            footer.parentNode.insertBefore(recommendations, footer.nextSibling);
          }
        } else if (items && recommendations && !footer) {
          if (items.nextElementSibling !== recommendations) {
            items.parentNode.insertBefore(recommendations, items.nextSibling);
          }
        }
      }
      
      // Trigger event to reinitialize cart recommendations functionality
      // Wait for cart drawer content to be loaded before dispatching event
      setTimeout(() => {
        fetch('/cart.js')
          .then(response => {
            return response.json();
          })
          .then(cartData => {
            // Check if cart drawer recommendations section exists
            const recommendationsSection = document.querySelector('.cart-drawer__recommendations');
            const productGrid = document.getElementById('you-may-love-product-grid');
            
            document.dispatchEvent(new CustomEvent('cartRecommendationsUpdated', { detail: cartData }));
            
            // Fallback: If function doesn't exist, try to execute the script manually
            if (typeof window.updateDynamicRecommendations !== 'function') {
              // Try to find and execute the script from cart-recommendations-drawer
              const recommendationsContainer = document.querySelector('.cart-drawer__recommendations');
              if (recommendationsContainer) {
                const scripts = recommendationsContainer.querySelectorAll('script');
                scripts.forEach(script => {
                  if (script.textContent && script.textContent.includes('updateDynamicRecommendations')) {
                    try {
                      eval(script.textContent);
                      // Try calling the function after execution
                      setTimeout(() => {
                        if (typeof window.updateDynamicRecommendations === 'function') {
                          window.updateDynamicRecommendations(cartData);
                        }
                      }, 100);
                    } catch (error) {
                      console.error('Error executing script:', error);
                    }
                  }
                });
              }
            }
          })
          .catch(error => {
            console.error('Error fetching cart data:', error);
            // Fallback without cart data
            document.dispatchEvent(new CustomEvent('cartRecommendationsUpdated'));
          });
      }, 500); // Wait 500ms for cart drawer content to load
      
      // Update complete look section based on latest added item
      setTimeout(() => {
        const latestVariantId = localStorage.getItem('latestAddedVariantId');
        if (latestVariantId && typeof window.updateCompleteLookSection === 'function') {
          const finder = document.getElementById('complete-look-item-finder');
          if (finder) {
            let targetItem = finder.querySelector(`[data-variant-id="${latestVariantId}"][data-has-complete-look="true"]`);
            
            if (!targetItem) {
              const latestItem = finder.querySelector(`[data-variant-id="${latestVariantId}"]`);
              if (latestItem) {
                const productId = latestItem.getAttribute('data-product-id');
                targetItem = finder.querySelector(`[data-product-id="${productId}"][data-has-complete-look="true"]`);
              }
            }
            
            if (targetItem) {
              const productId = targetItem.getAttribute('data-product-id');
              const productHandle = targetItem.getAttribute('data-product-handle');
              window.updateCompleteLookSection(productId, latestVariantId, productHandle);
            }
          }
        }
      }, 300);
    })
    .catch((e) => {
      console.error(e);
    });
}